
import React from 'react'
import Popover from './Popover'
import AccountMenu from './AccountMenu'
import Avatar from './Avatar'

/**
 * AccountMenuButton component.
 */

export default function AccountMenuButton({ user, expanded, ...props }) {
  function content({ close }) {
    return <AccountMenu user={user} onSelect={close} />    
  }

  return <Popover content={content} position="top left">
    <Avatar
      size={2}
      name={user.name || user.email}
      cursor="pointer"
      {...props} />
  </Popover>
}
